// src/components/matching-intergenerationnel/HeirProfilCard.tsx
import React from "react";

interface HeirProfilCardProps {
  heirProfile: {
    name?: string;
    job?: string;
    city?: string;
    archetype?: {
      primary: string;
      confidence: number;
      content: { name: string; tagline: string; risk: string; need: string };
    };
    artKeywords?: string[];
  };
}

export default function HeirProfilCard({ heirProfile }: HeirProfilCardProps) {
  if (!heirProfile) return null;
  const archetype = heirProfile.archetype;

  return (
    <div className="rounded-2xl shadow-xl bg-gradient-to-br from-blue-200 via-purple-200 to-pink-100 p-6 max-w-sm mx-auto my-10">
      <div className="flex flex-col items-center">
        <div className="bg-white rounded-full w-16 h-16 flex items-center justify-center mb-3">
          <span role="img" aria-label="Palette" className="text-3xl">🎨</span>
        </div>
        <h2 className="text-2xl font-bold mb-1">{heirProfile.name || "Profil héritier"}</h2>
        <div className="text-md mb-1">{heirProfile.job}</div>
        <div className="text-gray-500">{heirProfile.city}</div>
      </div>
      <div className="mt-4 text-left">
        {archetype ? (
          <>
            <div className="font-semibold mb-1">Archétype de collectionneur</div>
            <div className="text-lg font-bold mb-1">{archetype.content.name}</div>
            <p className="text-sm text-gray-700 italic mb-2">{archetype.content.tagline}</p>
            <div className="text-xs text-gray-500 mb-3">Confiance : {archetype.confidence}%</div>
          </>
        ) : (
          <div className="font-semibold mb-1">Profil Psychologique IA</div>
        )}
        <div className="mt-3 text-xs text-gray-700">Préférences détectées :</div>
        <div className="flex flex-wrap gap-2 mt-1">
          {heirProfile.artKeywords?.map((kw, i) => (
            <span key={i} className="bg-blue-100 text-blue-700 rounded-full px-2 py-1 text-xs">{kw}</span>
          ))}
        </div>
      </div>
    </div>
  );
}
